import moment from 'moment';
import { tranText } from './comps/tranText';

export const FormatMoney = (key: number | string, splitStr = ',') => {
    let value;
    if (key || key === 0) {
        const tmpKey = key.toString();
        const reg = /(\d)(?=(\d{3})+$)/g;
        value = tmpKey.replace(reg, `$1${splitStr}`);
    }
    return value;
};

type FormatMap = { [key: string]: string };
export const dateFormatMap: FormatMap = {
    us: 'DD/MM/YYYY',
    jp: 'YYYY/MM/DD',
};

export const dateTimeFormatMap: FormatMap = {
    us: 'DD/MM/YYYY HH:mm:ss',
    jp: 'YYYY/MM/DD HH:mm:ss',
};

// 给coupon添加Notes
export const injectNotes = (coupon: any[], locale: string) => {
    const textObj = (tranText[locale] || tranText['us']).rules;

    const text = (name: string, data?: Record<string, string | number>) => {
        if (!data) {
            return textObj[name] || '';
        }
        let str = textObj[name];
        Object.keys(data).map((key) => {
            console.log(textObj[name], data, `{${key}}`, data[key]);
            str = str.replaceAll(`{${key}}`, data[key]);
        });
        console.log(str);
        return str;
    };

    return coupon?.map((coupon: any) => {
        const noteList: string[] = [text('site_rules'), text('order_rule')];
        // 不找零
        if (coupon?.prerequisite !== 'PRICES' && coupon?.discountType === 'fixed_amount') {
            noteList.push(text('purchas_rule'));
        }
        if (coupon?.prerequisite === 'PRICES' && coupon?.discountType === 'fixed_amount') {
            const couponPrice = parseInt(coupon?.amount);
            const priceRange = parseInt(coupon.prerequisiteRange);
            if (priceRange < couponPrice) {
                noteList.push(text('purchas_rule'));
            }
        }
        if (coupon?.goodId) noteList.push(text('product_rules', { product: coupon?.goodTitle || '' }));

        // 最低金额
        if (coupon?.prerequisite === 'PRICES') {
            const price = parseInt(coupon.prerequisiteRange);
            const currencySymbol = coupon?.currencySymbol || '';
            const prerequisiteRange = text('minimum_price', { price: currencySymbol + FormatMoney(price) });
            noteList.push(prerequisiteRange);
        }

        // 最低数量
        if (coupon?.prerequisite === 'QUANTITY') {
            const num = parseInt(coupon.prerequisiteRange);
            const prerequisiteRange = text('minimum_num', { num: num });
            noteList.push(prerequisiteRange);
        }

        // 过期天数
        const limitDay = Math.floor((coupon?.expiredDay || 0) / 60 / 24);
        if (coupon?.expiredFlag && coupon?.expiredType === 'DAY') {
            noteList.push(text('days_rules', { days: limitDay }));
        }
        // 时间 for 福利中心
        if (coupon?.couponId && coupon?.endTime && coupon?.expiredType === 'TIME') {
            const formater = dateTimeFormatMap[locale as string] || dateTimeFormatMap['us'];
            const startTime = moment(Number(coupon?.startTime)).format(formater);
            const endTime = moment(Number(coupon?.endTime)).format(formater);
            noteList.push(text('days_rules2', { startTime, endTime }));
        }

        // 时间 for 优惠券
        if (coupon?.coupon && coupon?.endTime) {
            const formater = dateTimeFormatMap[locale as string] || dateTimeFormatMap['us'];
            const startTime = moment(Number(coupon?.startTime)).format(formater);
            const endTime = moment(Number(coupon?.endTime)).format(formater);
            noteList.push(text('days_rules2', { startTime, endTime }));
        }

        // 时间 for 优惠券规则
        if (!(coupon?.coupon || coupon?.couponId) && coupon?.expiredFlag && coupon?.validEndTime && coupon?.expiredType === 'TIME') {
            const formater = dateTimeFormatMap[locale as string] || dateTimeFormatMap['us'];
            const startTime = moment(Number(coupon?.validStartTime)).format(formater);
            const endTime = moment(Number(coupon?.validEndTime)).format(formater);
            noteList.push(text('days_rules2', { startTime, endTime }));
        }

        // campaign限时型时间
        if (!coupon?.discountId && coupon?.campaignStartTime && coupon?.campaignEndTime) {
            const formater = dateFormatMap[locale as string] || dateFormatMap['us'];
            const startTime = moment(Number(coupon?.campaignStartTime)).format(formater);
            const endTime = moment(Number(coupon?.campaignEndTime)).format(formater);
            noteList.push(text('campaign_time_limit_text', { startTime, endTime }));
        }
        if (coupon?.extRuleDesc) {
            noteList.push(coupon?.extRuleDesc);
        }
        return { ...coupon, showMore: false, noteList };
    });
};
